import Register from './Register.jsx'

export default Register
